import React from "react";

import { Link } from "react-router-dom";

import { MdOutlineMarkEmailRead } from "react-icons/md";
import CheckBox from "components/common/checkBox/checkbox";
import { formatDateIntoDMYToDisplay, textTruncate } from "Utils/utils";
import { invoiceListStatusBadge } from "Utils/invoiceListStatusBadge";
import { HiOutlineEye } from "react-icons/hi";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { SiMicrosoftexcel } from "react-icons/si";

const COSInvoiceTabel = (props) => {
  const {
    item,
    isNewMode,
    checkboxes,
    handleCheckboxChange,
    handleDownload,
    handleEmailInvoice,
    isUserGracePeriodOver,
  } = props;

  if (!isNewMode) {
    return (
      <tr className='text-center even:bg-white odd:bg-gray-50'>
        <td className=' px-3 py-4 text-sm text-gray-500 text-start '>
          <div className='text-gray-500'>{item.ref_no}</div>
        </td>
        <td className=' px-3 py-4 text-sm text-gray-500 text-start capitalize'>
          <div className='text-gray-500 capitalize' title={item.created_by}>
            {textTruncate(item.created_by, 30, 29)}
          </div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-start'>
          <div className='text-gray-500'>
            {formatDateIntoDMYToDisplay(item.extraction_date)}
          </div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center'>
          <div className='text-gray-500'>
            {formatDateIntoDMYToDisplay(item.delivered_from)}
          </div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center'>
          <div className='text-gray-500'>
            {formatDateIntoDMYToDisplay(item.delivered_to)}
          </div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center'>
          <div className='text-gray-500'>{item?.num_delivered_ser}</div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center'>
          <div className='text-gray-500'>
            {`$${parseFloat(item.total_amount).toFixed(2) || 0}`}
          </div>
        </td>
        <td>
          <div className='flex justify-center gap-x-2 items-center'>
            <Link
              className='icon-eye-wrapper inline-block'
              to={`/cos/invoice-preview/${item.uuid}`}
              title='View'
            >
              <HiOutlineEye className='icon-size' />
            </Link>
            <span
              title={
                item.email_sent
                  ? `Email sent${item.email_sent_at ? ` on ${item.email_sent_at}` : ""}`
                  : "Email Invoice"
              }
              onClick={() =>
                !isUserGracePeriodOver &&
                handleEmailInvoice &&
                handleEmailInvoice(item)
              }
              className={`border p-1 rounded-md cursor-pointer hover:transition-all-custom ${
                item.email_sent
                  ? "text-blue-600 border-blue-600 bg-blue-50 hover:bg-blue-600 hover:text-white"
                  : "text-gray-500 border-gray-400 hover:text-white hover:bg-gray-500 hover:border-gray-500"
              } ${item.email_sent || isUserGracePeriodOver ? "cursor-default" : ""}`}
            >
              <MdOutlineMarkEmailRead className='h-4 w-4' />
            </span>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <>
      <tr className='text-center even:bg-white odd:bg-gray-50'>
        <td className='whitespace-nowrap pl-3 py-4 text-sm text-gray-500'>
          <div className='text-gray-500'>
            <CheckBox
              isDisabled={isUserGracePeriodOver}
              handleChange={handleCheckboxChange}
              checked={checkboxes?.indexOf(item.uuid) !== -1}
            />
          </div>
        </td>
        <td className=' px-3 py-4 text-sm text-gray-500 text-start '>
          <div className='text-gray-500'>{item.ref_no}</div>
        </td>
        {isNewMode && (
          <td className=' px-3 py-4 text-sm text-gray-500 text-start capitalize'>
            <div
              className='text-gray-500 capitalize'
              title={item.participant_name || "-"}
            >
              {item.participant_name || "-"}
            </div>
          </td>
        )}
        <td className=' px-3 py-4 text-sm text-gray-500 text-start capitalize'>
          <div className='text-gray-500 capitalize' title={item.created_by}>
            {textTruncate(item.created_by, 30, 29)}
          </div>
        </td>

        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-start'>
          <div className='text-gray-500'>
            {formatDateIntoDMYToDisplay(item.extraction_date)}
          </div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center'>
          <div className='text-gray-500'>
            {formatDateIntoDMYToDisplay(item.delivered_from)}
          </div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center'>
          <div className='text-gray-500'>
            {formatDateIntoDMYToDisplay(item.delivered_to)}
          </div>
        </td>
        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center'>
          <div className='text-gray-500'>{item?.num_delivered_ser}</div>
        </td>

        <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center'>
          <div className='text-gray-500'>
            {`$${parseFloat(item.total_amount).toFixed(2) || 0}`}
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-sm text-center">
          {invoiceListStatusBadge(item?.status)}
        </td>
        <td>
          <div className='flex justify-center gap-x-2 items-center'>
            <Link
              className='icon-eye-wrapper inline-block'
              to={`/cos/invoice-preview/${item.uuid}`}
              title='View'
            >
              <HiOutlineEye className='icon-size' />
            </Link>
            <span
              title='Download PDF'
              onClick={() => handleDownload(item, "pdf")}
              className='text-rose-600 border border-rose-600 p-1 rounded-md cursor-pointer hover:text-white hover:border-rose-600 hover:bg-rose-600 hover:transition-all-custom'
            >
              <BsFillFileEarmarkPdfFill className='h-4 w-4' />
            </span>

            <span
              title='Download Excel'
              onClick={() => handleDownload(item, "xlsx")}
              className='text-green-700 border border-green-700 p-1 rounded-md cursor-pointer hover:text-white border hover:border-green-700 hover:bg-green-700 hover:transition-all-custom'
            >
              <SiMicrosoftexcel className='h-4 w-4' />
            </span>
            <span
              title={
                item.email_sent
                  ? `Email sent${item.email_sent_at ? ` on ${item.email_sent_at}` : ""}`
                  : "Email Invoice"
              }
              onClick={() =>
                !isUserGracePeriodOver &&
                handleEmailInvoice &&
                handleEmailInvoice(item)
              }
              className={`border p-1 rounded-md cursor-pointer hover:transition-all-custom ${
                item.email_sent
                  ? "text-blue-600 border-blue-600 bg-blue-50 hover:bg-blue-600 hover:text-white"
                  : "text-gray-500 border-gray-400 hover:text-white hover:bg-gray-500 hover:border-gray-500"
              } ${item.email_sent || isUserGracePeriodOver ? "cursor-default" : ""}`}
            >
              <MdOutlineMarkEmailRead className='h-4 w-4' />
            </span>
          </div>
        </td>
      </tr>
    </>
  );
};

export default COSInvoiceTabel;
